import request from '@/utils/request'

let StoreApi = {

  /*添加提货站点*/
  addShop(data, errorback) {
    return request._postBody('/supplier/store/store/add', data, errorback);
  },

  /*提货站点详情*/
  shopDetail(data, errorback) {
    return request._get('/supplier/store/store/toEdit', data, errorback);
  },

  /*提货站点编辑*/
  editShop(data, errorback) {
    return request._postBody('/supplier/store/store/edit', data, errorback);
  },

  /*删除提货站点*/
  deleteShop(data, errorback) {
    return request._postBody('/supplier/store/store/delete', data, errorback);
  },

  /*提货站点列表*/
  shoplist(data, errorback) {
    return request._postBody('/supplier/store/store/index', data, errorback);
  },

  /*提货站点选择列表*/
  storeLists(data, errorback) {
    return request._post('/supplier/store/store/lists', data, errorback);
  },

  /*核销专员列表*/
  clerklist(data, errorback) {
    return request._postBody('/supplier/store/clerk/index', data, errorback);
  },

  /*核销专员添加*/
  toAddClerk(data, errorback) {
    return request._get('/supplier/store/clerk/toAdd', data, errorback);
  },

  /*核销专员添加*/
  addClerk(data, errorback) {
    return request._postBody('/supplier/store/clerk/add', data, errorback);
  },

  /*核销专员详情*/
  clerkDetail(data, errorback) {
    return request._get('/supplier/store/clerk/toEdit', data, errorback);
  },

  /*核销专员编辑*/
  editClerk(data, errorback) {
    return request._postBody('/supplier/store/clerk/edit', data, errorback);
  },

  /*删除核销专员*/
  deleteClerk(data, errorback) {
    return request._post('/supplier/store/clerk/delete', data, errorback);
  },

  /*弹出层查询*/
  search(data, errorback) {
    return request._post('/supplier/store/clerk/search', data, errorback);
  },

  /*核销订单列表*/
  orderList(data, errorback) {
    return request._postBody('/supplier/store/order/index', data, errorback);
  },
}

export default StoreApi;



// WEBPACK FOOTER //
// ./src/api/store.js